import React from 'react';
import cx from 'classnames';

import CommentReply from '../Comment/CommentReply';
import { COMMENT } from '../../../../enums/TYPES';
import styles from './Reply.module.scss';

type TReply = {
  comment: COMMENT;
  disable: boolean;
  videofeedId: string;
  fetch: (value: string) => void;
  onDelete: (comment: COMMENT) => void;
  onEditSubmit?: (comment: COMMENT, newMessage: string) => void;
  lastReply: boolean;
  setImpertivlyShowFooter: (b: boolean) => void;
  imperativlyShowFooter: boolean;
  highlightReplies: boolean;
  parentDeleted?: boolean;
};

const Reply: React.FC<TReply> = ({
  comment,
  videofeedId,
  fetch,
  onDelete,
  onEditSubmit,
  disable,
  lastReply,
  imperativlyShowFooter,
  setImpertivlyShowFooter,
  highlightReplies,
  parentDeleted,
}) => {
  return (
    <div className={cx(styles.replyWrapper, styles.highlight, highlightReplies && styles.hoveredHighlight)} key={comment.id}>
      <CommentReply
        videofeedId={videofeedId}
        fetch={fetch}
        comment={comment}
        small
        onDelete={onDelete}
        onEditSubmit={onEditSubmit}
        disable={disable}
        parentDeleted={parentDeleted}
        lastReply={lastReply}
        imperativlyShowFooter={imperativlyShowFooter}
        setImpertivlyShowFooter={setImpertivlyShowFooter}
      />
    </div>
  );
};

export default Reply;
